import { pipelineId, pipelineSchemaLibraryId, schemaLibraryVersionId } from '../fixture-ids';

export const pipelineSchemaLibraryLegacyAlternates = {};

export const pipelineSchemaLibraryLegacyFixtures = {
  // No join-row id in legacy at all (the current generation adds one), and no alternate identity
  // is declared for it -- same as legacy PIPELINE_TAG_ADDED_TO_PIPELINE: the row degrades to
  // keyValue and is unattributed with reason identityUnresolved (no parentNameKeys is declared for
  // this action either).
  SCHEMA_LIBRARY_ADDED_TO_PIPELINE: {
    action: 'SCHEMA_LIBRARY_ADDED_TO_PIPELINE',
    debugData: {
      schemaLibraryVersionId,
      schemaLibraryName: 'Core Events',
      pipelineId,
      pipelineName: 'Web Analytics',
    },
  },
  // Legacy `id` IS the same pipeline_schema_libraries.id as current -- identity resolves via the
  // existing core idKeys:['id'], no alias needed.
  SCHEMA_LIBRARY_REMOVED_FROM_PIPELINE: {
    action: 'SCHEMA_LIBRARY_REMOVED_FROM_PIPELINE',
    debugData: { id: pipelineSchemaLibraryId, pipelineName: 'Web Analytics', schemaLibraryName: 'Core Events' },
  },
};
